import PropTypes from 'prop-types';
import React from 'react';

import LoadingSpinner from './loading-spinner';

const LoadingSectionWrapper = ( Component ) => {

    function LoadingComponent( { isLoading, ...props } ){
        if( isLoading ){
            return <LoadingSpinner />;
        }
        return <Component {...props} />;
    };

    LoadingComponent.propTypes = {
        isLoading: PropTypes.bool.isRequired,
    };

    return LoadingComponent;
};

LoadingSectionWrapper.propTypes = {
    Component: PropTypes.node,
};

export default  LoadingSectionWrapper;
